import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './FormCotacao.css';
import CustomSelect from './CustomSelect'; // Importando o CustomSelect

export default function FormCotacao() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    servico: null, // Usando null para o campo CustomSelect
    dataSaida: '',
    horaSaida: '',
    numeroPessoas: '',
    localSaida: '',
    localChegada: '',
    observation: '',
  });

  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectChange = (selectedOption) => {
    setFormData({
      ...formData,
      servico: selectedOption.label, // Atualizando o valor do serviço
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);

    const templateParams = {
      nome: formData.nome,
      email: formData.email,
      telefone: formData.telefone,
      servico: formData.servico,
      dataSaida: formData.dataSaida,
      horaSaida: formData.horaSaida,
      numeroPessoas: formData.numeroPessoas,
      localSaida: formData.localSaida,
      localChegada: formData.localChegada,
      observation: formData.observation,
    };

    emailjs
      .send('service_k983fdj', 'template_pj0qnyr', templateParams, '7AwUDu5FpwBjTI39M')
      .then((response) => {
        alert('Sua cotação foi enviada com sucesso!');
        console.log(templateParams);
        setIsSending(false);
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          servico: '',
          dataSaida: '',
          horaSaida: '',
          numeroPessoas: '',
          localSaida: '',
          localChegada: '',
          observation: '',
        });
      })
      .catch((err) => {
        alert('Ocorreu um erro ao enviar a cotação. Tente novamente mais tarde.');
        setIsSending(false);
      });
  };

  const selectOptions = [
    { value: 'transporte-executivo', label: 'Transporte Executivo' },
    { value: 'transfer-eventos', label: 'Transfer / Eventos' },
    { value: 'viagens-turismo', label: 'Viagens / Turismo' },
  ];

  return (
    <div className="cotacao-container">
      <h2>Contatação Rápida</h2>
      <p>Nós ligamos para você</p>
      <form className="cotacao-form" onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="form-group">
            <label htmlFor="nome">Nome</label>
            <input
              type="text"
              name="nome"
              id="nome"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="telefone">Telefone</label>
            <input
              type="text"
              name="telefone"
              id="telefone"
              value={formData.telefone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="servico">Serviço</label>
            <CustomSelect
              options={selectOptions}
              placeholder="Selecione um serviço"
              onChange={handleSelectChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="dataSaida">Data de Saída</label>
            <input
              type="date"
              name="dataSaida"
              id="dataSaida"
              value={formData.dataSaida}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="horaSaida">Hora de Saída</label>
            <input
              type="time"
              name="horaSaida"
              id="horaSaida"
              value={formData.horaSaida}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="numeroPessoas">Nº de pessoas</label>
            <input
              type="number"
              name="numeroPessoas"
              id="numeroPessoas"
              value={formData.numeroPessoas}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="localSaida">Local de Saída</label>
            <input
              type="text"
              name="localSaida"
              id="localSaida"
              value={formData.localSaida}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="localChegada">Local de Chegada</label>
            <input
              type="text"
              name="localChegada"
              id="localChegada"
              value={formData.localChegada}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="observation">Observação: </label>
            <textarea
              type="text"
              name="observation"
              id="observation"
              value={formData.observation}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <button type="submit" disabled={isSending}>
          {isSending ? 'Enviando...' : '✉️ Enviar pedido de cotação'}
        </button>
      </form>
    </div>
  );
}
